(() => {
  const script = document.currentScript;
  const helpLabel = script?.dataset.wishlistHelpLabel;
  if (window.ichikaProductPurchaseDecorated) return;
  window.ichikaProductPurchaseDecorated = true;
  const decorate = () => {
    document.querySelectorAll('[data-ichika-wishlist] .ichika-wishlist__button').forEach(button => {
      if (button.querySelector('.ichika-purchase-heart')) return;
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'ichika-purchase-heart');
      Object.entries({ viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.5', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false' }).forEach(([key,value]) => svg.setAttribute(key,value));
      const line = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      line.setAttribute('d', 'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z');
      svg.append(line); button.prepend(svg);
    });
    if (helpLabel) document.querySelectorAll('[data-ichika-wishlist] [data-help-product-link] a').forEach(link => { if (link.textContent !== helpLabel) link.textContent = helpLabel; });
  };
  decorate();
  let queued = false;
  const root = document.body;
  if (root) new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; decorate(); });
  }).observe(root, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', decorate);
  document.addEventListener('variant:change', decorate);
})();
